/** Re-export from provider — hook must run under WebViewportProvider. */
export {
  useWebViewport,
  type WebViewportState,
} from '@/core/providers/WebViewportProvider';
